import React from "react";
import TranslateWithLinks from "../../Utility/TranslateWithLinks";
import MemoText from "../MemoText";
export const Transfer = ({
  op,
  proposer,
  index,
  changeColor
}) => {
  changeColor("success"); // color of a label

  let memoComponent = null;

  if (op[1].memo) {
    memoComponent = /*#__PURE__*/React.createElement(MemoText, {
      memo: op[1].memo
    });
  }

  op[1].amount.amount = parseFloat(op[1].amount.amount);
  return /*#__PURE__*/React.createElement("span", {
    className: "right-td"
  }, /*#__PURE__*/React.createElement("div", {
    className: "inline-block"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TranslateWithLinks, {
    string: "operation.transfer",
    keys: [{
      type: "account",
      value: op[1].from,
      arg: "from"
    }, {
      type: "amount",
      value: op[1].amount,
      arg: "amount"
    }, {
      type: "account",
      value: op[1].to,
      arg: "to"
    }]
  }), memoComponent)));
};